import React, { useDebugValue, useEffect, useState } from "react";
import { Typography, Tooltip, IconButton, Input, Divider } from "@mui/material";
import { ReactComponent as SearchIcon } from "../../assets/images/SearchSvgIcon.svg";
import Popover from '@mui/material/Popover';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { httpRequest, automationHttpRequest } from "../../api/httpRequests";
import { ReactComponent as SortDown } from "../../assets/images/SortDown.svg";
import { ReactComponent as SortUp } from "../../assets/images/SortUp.svg";


const SearchFilter = ({ filter_values, searchFilterOPen, handleSearchClose, column_Name, filterColumns, handleFiltersearch, handleRequestSort }) => {

    const [final_filter_values, setFinal_filter_values] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [search_filter_values, setSearch_filter_values] = useState([])
    const [filterSearch, setFilterSearch] = useState(false)
    const [loading, setLoading] = useState(false);
    const [filterList, setFilterList] = useState([])
    const [filterValues, setFilterValues] = useState({
        description: [],
        storage_bin: [],
        storage_location: [],
        material_number: [],
        manufacturing_part_number: [],
        plant_name: [],
    })
   console.log(filterList)
    useEffect(() => {
        setFilterList([...filter_values])
        let selectedValues={}
        selectedValues["description"] =JSON.parse(localStorage.getItem("description")) || []
        selectedValues["manufacturing_part_number"] =JSON.parse(localStorage.getItem("manufacturing_part_number")) || []
        selectedValues["plant_name"] =JSON.parse(localStorage.getItem("plant_name")) || []
        selectedValues["material_number"] =JSON.parse(localStorage.getItem("material_number")) || []
        selectedValues["storage_location"] = JSON.parse(localStorage.getItem("storage_location")) || []
        selectedValues["storage_bin"] =JSON.parse(localStorage.getItem("storage_bin")) || []
        setFilterValues({...selectedValues})
        let temp = []
        if (filterColumns?.[column_Name] === "description") {
            temp = JSON.parse(localStorage.getItem("description"))
        }
        if (filterColumns?.[column_Name] === "manufacturing_part_number") {
            temp = JSON.parse(localStorage.getItem("manufacturing_part_number"))
        }
        if (filterColumns?.[column_Name] === "plant_name") {
            temp = JSON.parse(localStorage.getItem("plant_name"));
        }
        if (filterColumns?.[column_Name] === "material_number") {
            temp = JSON.parse(localStorage.getItem("material_number"))
        }
        if (filterColumns?.[column_Name] === "storage_location") {
            temp = JSON.parse(localStorage.getItem("storage_location"));
        }
        if (filterColumns?.[column_Name] === "storage_bin") {
            temp = JSON.parse(localStorage.getItem("storage_bin"))
        }
        if (filter_values?.length) {
            let all = [];
            let values = []
            if (temp?.length === filter_values?.length) {
                if(temp?.length === 1) {
                    all = [];
                } else {
                    all = [{ "key": "Select All", "checked": true }];
                }
                values = filter_values && filter_values.slice(0,100)?.map((val, index) => {
                    let temp = {};
                    temp.key = val;
                    temp.checked = true;
                    return { ...temp };
                })
            } else {
                all = [{ "key": "Select All", "checked": false }];
                values = filter_values && filter_values.slice(0,100)?.map((val, index) => {
                    let tempVal = {};
                    if (temp?.includes(val)) {
                        tempVal.key = val;
                        tempVal.checked = true;
                    } else {
                        tempVal.key = val;
                        tempVal.checked = false;
                    }
                    return { ...tempVal };
                })
            }

            setFinal_filter_values([...all, ...values])
        }
    }, [filter_values])

    useEffect(() => {
        const delay = setTimeout(async () => {
            if (searchTerm) {
                setLoading(true)
                try {
                    const response = await httpRequest.post(
                        "/filter_find",
                        {col_filter_list: filterList},
                        {
                            headers: {
                                session_id: localStorage.getItem("session_id"),
                            },
                            params: {
                                filter_name: filterColumns?.[column_Name],
                                search_str: searchTerm.trim()
                            }
                        }
                    );

                    if (response?.data?.success) {
                        const data = response.data.filtered_list.slice(0, 100);
                        if (data?.length > 1) {
                            const all = [{ "key": "Select All", "checked": false }];
                            const values = data && data?.map((val, index) => {
                                let temp = {};
                                temp.key = val;
                                temp.checked = false;
                                return { ...temp };
                            })
                            setSearch_filter_values(response.data.filtered_list)
                            setFinal_filter_values([...all, ...values])
                        } else if (data?.length === 1) {
                            const values = data && data?.map((val, index) => {
                                let temp = {};
                                temp.key = val;
                                temp.checked = false;
                                return { ...temp };
                            })
                            setFinal_filter_values([...values])
                        } else {
                            setFinal_filter_values([])
                        }
                        setLoading(false)
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            }
        }, 300);

        return () => clearTimeout(delay);
    }, [searchTerm]);


    const ButtonFamily = () => {
        return (
            <>
                <div style={{ display: "flex"}}>
                    <button
                        type="submit"
                        className="ApplyButton"
                        style={{
                            fontSize: 16,
                            cursor: "pointer",
                            position: "relative",
                            fontFamily: "Verdana",
                        }}
                        onClick={(e) => {
                            e.preventDefault();
                            handleFiltersearch(filterValues)
                        }}
                    >
                        Apply
                    </button>
                    <button
                        type="submit"
                        className="checkbutton"
                        style={{
                            fontSize: 16,
                            cursor: "pointer",
                            position: "relative",
                            fontFamily: "Verdana",
                            top: "-1px"
                        }}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSearchClose()
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </>
        );
    };

    const handleUpdateFilterValue = (newSelected) => {
        let colName = filterColumns?.[column_Name]
        if (colName === "description") {
            let presentData;
            if(localStorage.getItem("description") && newSelected.length > 0){
                presentData = JSON.parse(localStorage.getItem("description"));
                localStorage.setItem("description", JSON.stringify(Array.from(new Set([...presentData, ...newSelected]))))
            }else {
                localStorage.setItem("description", JSON.stringify(newSelected))
            }
            if(presentData && newSelected.length > 0 ){
                setFilterValues({
                    ...filterValues,
                    description: Array.from(new Set([...presentData, ...newSelected])),
                });
            } else {
                setFilterValues({
                    ...filterValues,
                    description: typeof filter_search === "string" ? newSelected.split(",") : newSelected,
                });
            }
        }
        if (colName === "plant_name") {
            let presentData;
            if(localStorage.getItem("plant_name") && newSelected.length > 0){
                presentData = JSON.parse(localStorage.getItem("plant_name"));
                localStorage.setItem("plant_name", JSON.stringify(Array.from(new Set([...presentData, ...newSelected]))))
            }else {
                localStorage.setItem("plant_name", JSON.stringify(newSelected))
            }
            if(presentData && newSelected.length > 0 ){
                setFilterValues({
                    ...filterValues,
                    plant_name: Array.from(new Set([...presentData, ...newSelected])),
                });
            } else {
                setFilterValues({
                    ...filterValues,
                    plant_name: typeof filter_search === "string" ? newSelected.split(",") : newSelected,
                });
            }
        }
        if (colName === "manufacturing_part_number") {
            let presentData;
            if(localStorage.getItem("manufacturing_part_number") && newSelected.length > 0){
                presentData = JSON.parse(localStorage.getItem("manufacturing_part_number"));
                localStorage.setItem("manufacturing_part_number", JSON.stringify(Array.from(new Set([...presentData, ...newSelected]))))
            }else {
                localStorage.setItem("manufacturing_part_number", JSON.stringify(newSelected))
            }
            if(presentData && newSelected.length > 0 ){
                setFilterValues({
                    ...filterValues,
                    manufacturing_part_number: Array.from(new Set([...presentData, ...newSelected])),
                });
            } else {
                setFilterValues({
                    ...filterValues,
                    manufacturing_part_number: typeof filter_search === "string" ? newSelected.split(",") : newSelected,
                });
            }  
        }
        if (colName === "storage_location") {
            let presentData;
            if(localStorage.getItem("storage_location") && newSelected.length > 0){
                presentData = JSON.parse(localStorage.getItem("storage_location"));
                localStorage.setItem("storage_location", JSON.stringify(Array.from(new Set([...presentData, ...newSelected]))))
            }else {
                localStorage.setItem("storage_location", JSON.stringify(newSelected))
            }
            if(presentData && newSelected.length > 0 ){
                setFilterValues({
                    ...filterValues,
                    storage_location: Array.from(new Set([...presentData, ...newSelected])),
                });
            } else {
                setFilterValues({
                    ...filterValues,
                    storage_location: typeof filter_search === "string" ? newSelected.split(",") : newSelected,
                });
            }
        }
        if (colName === "material_number") {
            let presentData;
            if(localStorage.getItem("material_number") && newSelected.length > 0){
                presentData = JSON.parse(localStorage.getItem("material_number"));
                localStorage.setItem("material_number", JSON.stringify(Array.from(new Set([...presentData, ...newSelected]))))
            }else {
                localStorage.setItem("material_number", JSON.stringify(newSelected))
            }
            if(presentData && newSelected.length > 0 ){
                setFilterValues({
                    ...filterValues,
                    material_number: Array.from(new Set([...presentData, ...newSelected])),
                });
            } else {
                setFilterValues({
                    ...filterValues,
                    material_number: typeof filter_search === "string" ? newSelected.split(",") : newSelected,
                });
            }        
        }
        if (colName === "storage_bin") {
            let presentData;
            if(localStorage.getItem("storage_bin") && newSelected.length > 0){
                presentData = JSON.parse(localStorage.getItem("storage_bin"));
                localStorage.setItem("storage_bin", JSON.stringify(Array.from(new Set([...presentData, ...newSelected]))))
            }else {
                localStorage.setItem("storage_bin", JSON.stringify(newSelected))
            }
            if(presentData && newSelected.length > 0 ){
                setFilterValues({
                    ...filterValues,
                    storage_bin: Array.from(new Set([...presentData, ...newSelected])),
                });
            } else {
                setFilterValues({
                    ...filterValues,
                    storage_bin: typeof filter_search === "string" ? newSelected.split(",") : newSelected,
                });
            }
        }
    }

    const handleCheckbox = (e, data) => {

        if (e.target.checked) {
            if (data?.key === "Select All") {
                const checkedArray = final_filter_values?.map((ele, index) => {
                    return { ...ele, checked: true };
                })
                const selectItems = checkedArray?.filter(val => val.checked && val?.key !== "Select All")
                // const newSelected = selectItems.map((val) => val?.key)
                if(filterSearch) {
                    handleUpdateFilterValue(search_filter_values)
                } else {
                    handleUpdateFilterValue(filter_values)
                }
                setFinal_filter_values(checkedArray);
            } else {
                const checkedArray = final_filter_values?.map((ele, index) => {
                    if (ele?.key === data?.key) {
                        return { ...ele, checked: true };
                    } else {
                        return { ...ele };
                    }
                })
                const selectItems = checkedArray?.filter(val => val.checked && val?.key !== "Select All")
                const newSelected = selectItems.map((val) => val?.key)
                handleUpdateFilterValue(newSelected)
                setFinal_filter_values(checkedArray);
            }
        } else {
            if (data?.key === "Select All") {
                const checkedArray = final_filter_values?.map((ele, index) => {
                    return { ...ele, checked: false };
                })
                const selectItems = checkedArray?.filter(val => val.checked && val?.key !== "Select All")
                const newSelected = selectItems.map((val) => val?.key)
                handleUpdateFilterValue(newSelected)
                setFinal_filter_values(checkedArray);
            } else {
                const checkedArray = final_filter_values?.map((ele, index) => {
                    if (ele?.key === data?.key) {
                        return { ...ele, checked: false };
                    } else {
                        return { ...ele };
                    }
                })
                const selectItems = checkedArray?.filter(val => val.checked && val?.key !== "Select All")
                const newSelected = selectItems.map((val) => val.request_id)
                handleUpdateFilterValue(newSelected)
                setFinal_filter_values(checkedArray);
            }
        }
    };

    const handleChange = (event) => {
        if(event?.target?.value) {
            setFilterSearch(true)
        }else {
            setFilterSearch(false)
        }
        setSearchTerm(event?.target?.value)
    }

    return (
        <>
            <div className="popOverDialog">
            <div>
                    <div style ={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "space-between",
                        fontFamily: "Verdana",
                        // color: "#8a8e95",
                        width: "75%",
                        fontSize: "15px",
                        margin: "10px 10px 0px 15px",
                        fontWeight: "400",
                    }}>
                        <Typography>Sort Ascending</Typography>
                         <SortUp style={{ cursor: "pointer", position: "relative", left: "1px"}}
                          onClick={() => handleRequestSort(column_Name, "asc")}
                           />
                    </div>
                    <div style ={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontFamily: "Verdana",
                        width: "75%",
                        // color: "#8a8e95",
                        margin: "0px 4px",
                        fontSize: "15px",
                        margin: "10px 10px 10px 15px",
                        fontWeight: "400",
                    }}>
                        <Typography>Sort Descending</Typography>
                         <SortDown style={{ cursor: "pointer" }} 
                         onClick={() => handleRequestSort(column_Name, "desc")}
                          />
                    </div>
                </div>
                <Divider />
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        width: "90%",
                    }}
                >
                    {/* <IconButton
                        style={{
                            position: "absolute",
                            zIndex: 2,
                            fontSize: "0px",
                        }}
                    >
                        <SearchIcon />
                    </IconButton> */}
                    <input
                        placeholder="Search"
                        name="searchFilter"
                        autoComplete="off"
                        onChange={handleChange}
                        type="text"
                        value={searchTerm}
                        className="searchInput"
                    />
                </div>
                <Divider style={{ margin: "4px 0px" }} />
                {loading ? (
                    <>
                        <div style={{margin:"20px 0px 10px 20px"}}>Loading..</div>
                    </>
                ) : (
                    <>{final_filter_values?.length ? (
                        <>
                            <div>
                                {final_filter_values && final_filter_values?.map((val, index) => {
                                    return (
                                        <>
                                            {val?.key.length > 15 ? (
                                                <Tooltip title={val?.key} arrow placement="right">
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center"
                                                    }}>
                                                        <FormGroup>
                                                            <FormControlLabel sx={{ margin: "2px 10px" }} control={<Checkbox checked={val?.checked} onChange={(e) => handleCheckbox(e, val)} />} label={val?.key?.substring(0, 15)} />
                                                        </FormGroup>
                                                    </div>
                                                </Tooltip>
                                            ) : (
                                                <>
                                                    <FormGroup>
                                                        <FormControlLabel sx={{ margin: "2px 10px" }} control={<Checkbox checked={val?.checked} onChange={(e) => handleCheckbox(e, val)} />} label={val?.key} />
                                                    </FormGroup>
                                                </>
                                            )}
                                        </>
                                    )
                                })}
                            </div>
                        </>
                    ) : (
                        <div>
                            <Typography sx={{
                                textAlign: "center",
                                color: "#C6003D"
                            }}>No option found</Typography>
                        </div>
                    )}
                    </>
                )}
                <div className="fixed-bottom">
                    <ButtonFamily />
                </div>
            </div>
        </>
    )


}

export default SearchFilter;
